import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5439c5a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["element-loading-svg"];
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  class: "dialog-foter"
};
import { useActuatorManualOperation } from '@/composables/useActuatorManualOperation';
import moment from "moment";
import { reactive, watch, ref, unref, onMounted, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { updateState, finishedListPage, executeById } from "@/api/deviceManage";
import { techLoadingSvg } from '@/components/TechLoading/index.vue';
import { useStore } from "vuex";
const __default__ = {
  name: "todoList"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const manualOperation = useActuatorManualOperation();
    const route = useRoute();
    const store = useStore();
    const curUserId = store.state.common.userInfo.userId; //当前用户 id

    // 表格标题
    const tableTitle = computed(() => {
      return '已办事宜';
    });
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "开阀"
    }, {
      dictValue: 0,
      dictLabel: "关阀"
    }]);
    const formatCode = function (code, column) {
      if (code == 1) {
        return '驳回';
      } else if (code == 2) {
        return '同意';
      } else if (code == 3) {
        return '撤销';
      } else {
        return '待审核';
      }
    };
    const state = reactive({
      dialogVisible: false,
      applyForm: {
        auditComment: ''
      },
      curId: null,
      applyRules: {
        auditComment: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      },
      open: false,
      // 表单参数
      form: {
        actNum: '',
        opStartTime: '',
        opEndTime: '',
        originDate: "",
        applyReason: '',
        angleValue: ""
      },
      rules: {
        actNum: [{
          required: true,
          message: "请输入设备编号",
          trigger: "blur"
        }],
        angleValue: [{
          required: true,
          message: "请选择执行操作",
          trigger: "blur"
        }],
        originDate: [{
          required: true,
          message: '请选择执行时间',
          trigger: 'blur'
        }],
        applyReason: [{
          required: true,
          message: '请输入申请事由',
          trigger: 'blur'
        }]
      },
      saveLoading: false,
      formData: [{
        prop: "actNum",
        label: "设备编号",
        placeholder: "请输入设备编号",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "originDate",
        label: "执行时间",
        placeholder: "请选择执行时间",
        type: "datetimerange",
        multiple: true,
        span: 24,
        change: val => {
          if (val?.length) {
            state.form.opStartTime = val[0];
            state.form.opEndTime = val[1];
          } else {
            state.form.opStartTime = '';
            state.form.opEndTime = '';
          }
        }
      }, {
        prop: "angleValue",
        label: "执行操作",
        placeholder: "请选择执行操作",
        type: "radio",
        isSelect: false,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "applyReason",
        label: "申请事由",
        placeholder: "请输入申请事由",
        type: "textarea",
        isSelect: false,
        span: 24
      }],
      tableData: {
        rows: [],
        total: 0
      }
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      actNum: ''
    });
    const searchFormData = ref([{
      prop: "actNum",
      label: "执行器编号",
      placeholder: "请输入执行器编号",
      type: "text",
      span: 4
    }]);
    let loading = ref(false);
    let loading1 = ref(false);
    const closeApply = () => {
      state.dialogVisible = false;
    };
    const getList = () => {
      loading.value = true;
      finishedListPage(queryParams).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const applyFormRef = ref(null);
    const submitAudit = () => {
      const formEl = unref(applyFormRef);
      formEl.validate(valid => {
        if (valid) {
          loading.value = true;
          let params = {
            "auditComment": state.applyForm.auditComment,
            "auditState": 1,
            "id": state.curId
          };
          updateState(params).then(res => {
            ElMessage.closeAll();
            if (res.code == 0) {
              ElMessage.success("操作成功");
            } else {
              ElMessage.error(res.msg);
            }
          }).finally(() => {
            loading.value = false;
          });
        }
      });
    };
    const resetQuery = () => {
      queryParams.pageNum = 1;
      queryParams.pageSize = 10;
      queryParams.actNum = "";
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      class: "btn-liquid",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "actNum",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "location",
      label: "设备位置",
      fixed: false,
      type: "text"
    }, {
      prop: "applyUser",
      label: "申请人",
      fixed: false,
      type: "text"
    }, {
      prop: "applyReason",
      label: "申请事由",
      fixed: false,
      type: "text"
    }, {
      prop: "applyTime",
      label: "申请时间",
      fixed: false,
      type: "text"
    }, {
      prop: "auditUser",
      label: "审核人",
      fixed: false,
      type: "text"
    }, {
      prop: "auditTime",
      label: "审核时间",
      fixed: false,
      type: "text"
    }, {
      prop: "auditComment",
      label: "驳回原因",
      fixed: false,
      type: "text"
    },
    // 1-驳回申请；2-同意申请；3-撤回申请
    {
      prop: "opStartTime",
      label: "计划开始时间",
      fixed: false,
      type: "text"
    }, {
      prop: "opEndTime",
      label: "计划结束时间",
      fixed: false,
      type: "text"
    }, {
      prop: "exStartTime",
      label: "执行开始时间",
      fixed: false,
      type: "text"
    }, {
      prop: "exEndTime",
      label: "执行结束时间",
      fixed: false,
      type: "text"
    }, {
      prop: "exResult",
      label: "执行结果",
      fixed: false,
      type: "text",
      statusList: [{
        value: 1,
        label: "成功"
      }, {
        value: 0,
        label: "失败"
      }]
    }, {
      prop: "auditState",
      label: "状态",
      formatData: formatCode,
      type: function (row) {
        if (row.auditState == 1) {
          return 'error';
        } else if (row.auditState == 2) {
          return 'success';
        } else if (row.auditState == 3) {
          return 'warning';
        } else {
          return 'info';
        }
      }
    }, {
      prop: "operation",
      label: "操作",
      width: "200px",
      fixed: 'right',
      operation: [{
        name: '执行',
        clickFun: row => handleOperate(row),
        hasPermi: [],
        disabledHandle(row) {
          return row.auditState != 2 || curUserId != row.applyUserId || !!row.exStartTime || manualOperation.busy.value;
        }
      }]
    }];

    // 执行
    const handleOperate = async row => {
      if (manualOperation.busy.value || row.exStartTime) return;
      loading1.value = true;
      try {
        await manualOperation.run(() => executeById(row.id), {
          operation: row.valuePos == 1 ? '开阀' : '关阀'
        });
      } finally {
        loading1.value = false;
        // 包括查询中断的情况：已提交的工单仍可能执行，不恢复重复执行按钮。
        getList();
      }
    };
    // 重新申请
    const handleRetry = row => {
      state.open = true;
      state.form = {
        ...row
      };
      state.form.originDate = [row.opStartTime, row.opEndTime];
    };
    const submit = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          params.protocolType = "mqtt";
          delete params.originDate;
          if (state.form.id) {
            updateAudit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("申请成功");
                state.openDataScope = false;
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addAudit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    const cancel = function () {
      state.open = false;
    };
    onMounted(async () => {});
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "app-container",
        "element-loading-custom-class": "tech-loading",
        "element-loading-svg": _unref(techLoadingSvg),
        "element-loading-svg-view-box": "0 0 120 120"
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-ceshijilu",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.open = $event),
        size: "600px",
        title: "我的申请",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("立即申请")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref: "form",
          form: state.form,
          formRules: state.rules,
          formData: state.formData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue"])], 8, _hoisted_1)), [[_directive_loading, _unref(manualOperation).busy.value ? {
        text: _unref(manualOperation).progressText.value
      } : false]]);
    };
  }
});